import React, {useState, useContext, useEffect} from 'react';
import { IonMenu, IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonContent, IonList, IonMenuToggle, IonItem, IonLabel, IonButton, IonIcon, useIonRouter, IonModal, IonGrid, IonRow, IonCol, IonFooter } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
//import { PayModal_Subscription } from './Modal_Pay_Subscription';
import { Retail_AccountSetting } from '../../../retail/merchant/views/retail_accountSetting';
//import {ConfirmMerchantLogout} from './pages/zPublic/components/MerchantLogout';
import {ConfirmMerchantLogout} from '../../../zPublic/components/MerchantLogout';

import { useHistory} from "react-router-dom";



export function Subscription_Alert (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);

    let [viewPayModalSubscription, setViewPayModalSubscription] = useState(false);

    let [viewSubscriptionBills, setViewSubscriptionBills] = useState([]);
    let [subscriptionID, setSubscriptionID] = useState(null);
    let [bill_dueDate, setBill_dueDate] = useState(null);
    let [bill_amount, setBill_amount] = useState(null);
    let [zasavaCompanyID, setZasavaCompanyID] = useState('1');

    let [accountSettingsModal, setAccountSettingsModal] = useState(false)
    let [logoutModal, setLogoutModal] = useState(false)
    let [confirmLogout, setConfirmLogout] = useState(false);

    let history = useHistory();
    let router = useIonRouter();


    function handleRoute(event)
    {
        // alert(event);
        // alert(window.location.pathname);

        //history.push(event);
            window.location.href = event;

    }
    //alert("IN SIDE MENUI");

        return (
            <React.Fragment>
            
                        
            {props.openModal == true ?
            (
                <IonModal isOpen={ props.openModal }>
                    <IonHeader style={{color: 'black'}}>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    {authenticatedMerchent_context.accessRights[0] == 'admin' 
                                ?<h3>INACTIVE SUBSCRIPTION - PLEASE RENEW TO CONTINUE USING</h3>
                                :<h3> LOGIN DENIED</h3>}
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonContent className='grid_content'>

                    <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                {authenticatedMerchent_context.accessRights[0] == 'admin' 
                                ?<h3 >Please Click below to navigate to Account Settings</h3>
                                :<h3> Please contact your administrator.  Also try logging out, then log back in.</h3>}
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton onClick={() => setAccountSettingsModal(true)} >Account Settings</IonButton>}
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                    {accountSettingsModal == true && <Retail_AccountSetting openModal={ accountSettingsModal } closeModal={() => setAccountSettingsModal(false)}></Retail_AccountSetting>}
                    {/*{logoutModal == true && <ConfirmMerchantLogout openModal={ logoutModal } closeModal={() => setLogoutModal(false)}></ConfirmMerchantLogout>}*/}
                {confirmLogout == true && <ConfirmMerchantLogout openModal={confirmLogout} data={{
                                            source: 'complete_logout',
                                            acctID: acctID,
                                            schema: schema,
                                            sessionID: sessionID,
                                            baseURL: baseURL
                }}></ConfirmMerchantLogout>}

                    </IonContent>
                    <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonButton onClick={() => setConfirmLogout(true)}> Logout </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>
                </IonModal>
           
        ) : null }
    </React.Fragment>

        )
    }